import React from 'react';
import { Modal } from 'react-bootstrap';

const ModalContentLoading = () =>
  <Modal.Body className="companies-modal-loading">
    <i className="fad fa-spinner fa-pulse" aria-hidden="true"></i>
    <p className="padding-top-5">Loading company data</p>
  </Modal.Body>

export default ModalContentLoading;